module.exports = __webpack_public_path__ + "static/assets/6bd478575b22e49350c20609a6212bdb.svg";